import { utils } from "@alife/cone-arms-core";
var checkWin = utils.checkWin, getXPath = utils.getXPath;
var domChangeHandleList = [];
export var bindDomChangeEvent = function(fn) {
    if (typeof fn === "function" && domChangeHandleList.indexOf(fn) === -1) {
        domChangeHandleList.push(fn);
    }
};
export var init = function() {
    var tables = {};
    var maxNodesCount = 0;
    var timer;
    var unbind = function() {
        clearInterval(timer);
    };
    if (checkWin()) {
        var changeHandle = function() {
            var _document_querySelectorAll;
            if (!checkWin()) {
                return;
            }
            var curNodesCount = ((_document_querySelectorAll = document.querySelectorAll("*")) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.length) || 0;
            if (curNodesCount > maxNodesCount) {
                maxNodesCount = curNodesCount;
            }
            var curTables = document.querySelectorAll('[data-name="CnTable"]');
            if (curTables && curTables.length > 0) {
                curTables.forEach(function(table) {
                    if (table) {
                        var xpath = getXPath(table, 5);
                        if (!tables[xpath]) {
                            var _table_querySelectorAll;
                            tables[xpath] = {
                                xpath: xpath,
                                columns: ((_table_querySelectorAll = table.querySelectorAll("thead>tr>th")) === null || _table_querySelectorAll === void 0 ? void 0 : _table_querySelectorAll.length) || 0
                            };
                        } else {
                            var _table_querySelectorAll1;
                            var columns = ((_table_querySelectorAll1 = table.querySelectorAll("thead>tr>th")) === null || _table_querySelectorAll1 === void 0 ? void 0 : _table_querySelectorAll1.length) || 0;
                            if (columns > tables[xpath].columns) {
                                tables[xpath].columns = columns;
                            }
                        }
                    }
                });
            }
            domChangeHandleList.forEach(function(fn) {
                if (typeof fn === "function") {
                    fn();
                }
            });
        };
        if (typeof MutationObserver !== "undefined") {
            var observerTimer = null;
            var observerHandle = function() {
                if (observerTimer) {
                    clearTimeout(observerTimer);
                }
                observerTimer = setTimeout(function() {
                    changeHandle();
                }, 300);
            };
            var observerMutation = new MutationObserver(observerHandle);
            observerMutation.observe(document.documentElement, {
                childList: true,
                subtree: true
            });
            unbind = function() {
                observerMutation.disconnect();
            };
        } else {
            timer = setInterval(changeHandle, 1000);
        }
    }
    return {
        reset: function() {
            maxNodesCount = 0;
            tables = {};
        },
        unbind: unbind,
        getData: function() {
            var tableList = Object.keys(tables).map(function(key) {
                return tables[key];
            });
            return {
                maxNodesCount: maxNodesCount,
                tables: tableList,
                bigTableCount: tableList.filter(function(table) {
                    return table.columns > 10;
                }).length
            };
        }
    };
};

 //# sourceMappingURL=observe-domtree-change.js.map